<template>
  <VersionComparator>
    <CompareCommissionQuestions />
  </VersionComparator>
</template>

<script>
import VersionComparator from '@/components/compare/VersionComparator'
import CompareCommissionQuestions from '@/components/expCommissionQuestions/CompareCommissionQuestions'

export default {
  name: 'CompareCommissionQuestionsPage',
  components: {
    VersionComparator,
    CompareCommissionQuestions,
  },
}
</script>
